import { render } from "./TrainingForm.vue?vue&type=template&id=2a4d989e&scoped=true"
import script from "./TrainingForm.vue?vue&type=script&lang=js"
export * from "./TrainingForm.vue?vue&type=script&lang=js"

import "./TrainingForm.vue?vue&type=style&index=0&id=2a4d989e&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4d989e"]])

export default __exports__